import {userData} from "./stores";
import { Base64 } from 'js-base64';

export default async function updateUserData() {
    const userDataCookieString = await getCookie("jwt_payload")
    let userDataValue
    if (userDataCookieString) {
        // userDataValue = await JSON.parse(window.atob(userDataCookieString))
        userDataValue = await JSON.parse(Base64.decode(userDataCookieString))
    } else {
        userDataValue = null
    }
    userData.set(userDataValue)
}